// Discreet ES/EN language switch (runtime language support). Rendered on the two
// main entry surfaces — the guest scan landing and the staff dashboard — as a small
// footer control, visually secondary to the screen's real work.
//
// Selecting a language persists it and reloads: strings are bound when the i18n
// module loads (see src/i18n/index.ts), so a reload at this screen boundary is the
// honest way to apply the choice everywhere. The current language never shows as
// clickable, which also makes the active choice visible.
//
// Not rendered inside a kiosk's call window: there the kiosk sets the language.
import { currentLanguage, setLanguage, t } from '../i18n'
import type { Language } from '../i18n'
import { embeddedInKiosk } from '../launchContext'

const LANGUAGES: { code: Language; label: string }[] = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
]

const LanguageSwitch = () => {
  if (embeddedInKiosk) return null
  const name = (code: Language) => (code === 'es' ? t.languageSpanish : t.languageEnglish)

  return (
    <div className="cf-lang-switch" role="group" aria-label={t.languageSwitchLabel}>
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={`cf-lang-switch-option${code === currentLanguage ? ' active' : ''}`}
          aria-pressed={code === currentLanguage}
          aria-label={name(code)}
          onClick={() => setLanguage(code)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitch
